import React, { useState, useEffect } from 'react';
import PaymentMethodProvider from './PaymentMethodProvider';
import { PAYMENT_METHOD } from '../libs/polygon-ordering/src/constants/paymentMethod';
import Text from './Text';
import RedcatImage from './RedcatImage';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { useFormikContext } from 'formik';
import { dollarsToCents } from '../libs/polygon-ordering/src/utils/misc';

const GooglePayProvider = () => {
  const [googlePayEnabled, setGooglePayEnabled] = useState<boolean | null>(null);
  const stripe = useStripe();
  const elements = useElements();
  const { values } = useFormikContext<FormikFields>();

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'AU',
      currency: 'aud',
      total: {
        label: 'Payment Total:',
        amount: dollarsToCents(values.Amount!) || 0,
      },
    });

    pr.canMakePayment().then(result => {
      if (result?.googlePay) {
        setGooglePayEnabled(true);
      }
    });
  }, [stripe, elements]);

  return (
    <>
      {googlePayEnabled && (
        <PaymentMethodProvider
          method={PAYMENT_METHOD.GOOGLE_PAY}
          right={
            <div style={styles.buttonContainer}>
              <div style={styles.markContainer}>
                <RedcatImage
                  imagePath={
                    'https://assets.redcatcloud.com.au/webordering/GPay_Acceptance_Mark_800.png'
                  }
                  size={60}
                />
              </div>
            </div>
          }
          subtitle={<Text themeKey="paymentMethodUnavailableReason">&nbsp;</Text>}
        />
      )}
    </>
  );
};

const styles: Styles = {
  buttonContainer: {
    position: 'relative',
  },
  markContainer: {
    position: 'absolute',
    top: -32,
    left: 'auto',
    right: 0,
  },
};

export default GooglePayProvider;
